import { ApplePayButtonLogo } from './ApplePayButtonLogo';

/**
 * Visual-only Apple Pay button. Matches WebKit's native PaymentRequest
 * button (black pill, white  Pay glyph centered) so the swap to the
 * real Apple-rendered button is imperceptible.
 *
 * No interaction handlers — clicks are blocked by the parent
 * `WalletButtonShell`'s overlay. This component never sees an event.
 */
export const ApplePayButtonPlaceholder = (): JSX.Element => (
  <div
    aria-hidden="true"
    className="wallet-visual-button w-full rounded-lg bg-black"
    data-testid="wallet-placeholder-apple"
  >
    <ApplePayButtonLogo />
  </div>
);
